export type OutlineButtonFace = 'positive' | 'negative' | 'brand' | 'neutral'
